export const headerName = {
  add: "Добавить запись",
  edit: "Редактировать запись",
};
export const organizationsData = {
  name: {
    key: "name",
    label: "Полное наименование",
    type: "text",
    required: true,
    upperCase: false,
  },
  shortName: {
    key: "shortName",
    label: "Краткое наименование",
    type: "text",
    required: false,
    upperCase: false,
  },
  address: {
    key: "address",
    label: "Адрес",
    type: "text",
    required: false,
    upperCase: false,
  },
  phone: {
    key: "phone",
    label: "Телефон",
    type: "text",
    required: false,
    upperCase: false,
    pattern: {
      value: /^[0-9+\s,;()-]*$/,
      message: `Недопустимые символы: введите цифры, (), -, +`,
    },
  },
};
